import type { MazeLayout } from '../../types';

/**
 * Cross layout - central cross pattern (28x31)
 */
export const layout4: MazeLayout = {
  id: 'cross',
  name: 'Cross',
  width: 28,
  height: 31,
  grid: [
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,3,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,3,0],
    [0,2,0,0,0,0,2,0,0,0,0,0,0,2,2,0,0,0,0,0,0,2,0,0,0,0,2,0],
    [0,2,0,0,0,0,2,0,0,0,0,0,0,2,2,0,0,0,0,0,0,2,0,0,0,0,2,0],
    [0,2,0,0,0,0,2,0,0,0,0,0,0,2,2,0,0,0,0,0,0,2,0,0,0,0,2,0],
    [0,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,0],
    [0,2,0,0,0,0,2,0,0,0,0,0,0,2,2,0,0,0,0,0,0,2,0,0,0,0,2,0],
    [0,2,0,0,0,0,2,0,0,0,0,0,0,2,2,0,0,0,0,0,0,2,0,0,0,0,2,0],
    [0,2,0,0,0,0,2,0,0,0,0,0,0,2,2,0,0,0,0,0,0,2,0,0,0,0,2,0],
    [0,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,0],
    [0,2,0,0,0,0,2,0,0,0,0,0,1,2,2,1,0,0,0,0,0,2,0,0,0,0,2,0],
    [0,2,0,0,0,0,2,0,0,1,1,1,1,2,2,1,1,1,1,0,0,2,0,0,0,0,2,0],
    [0,2,0,0,0,0,2,0,0,1,0,0,0,5,5,0,0,0,1,0,0,2,0,0,0,0,2,0],
    [0,2,2,2,2,2,2,2,2,1,0,4,4,4,4,4,4,0,1,2,2,2,2,2,2,2,2,0],
    [6,2,2,2,2,2,2,2,2,1,0,4,4,4,4,4,4,0,1,2,2,2,2,2,2,2,2,6],
    [0,2,2,2,2,2,2,2,2,1,0,4,4,4,4,4,4,0,1,2,2,2,2,2,2,2,2,0],
    [0,2,0,0,0,0,2,0,0,1,0,0,0,0,0,0,0,0,1,0,0,2,0,0,0,0,2,0],
    [0,2,0,0,0,0,2,0,0,1,1,1,1,2,2,1,1,1,1,0,0,2,0,0,0,0,2,0],
    [0,2,0,0,0,0,2,0,0,0,0,0,1,2,2,1,0,0,0,0,0,2,0,0,0,0,2,0],
    [0,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,0],
    [0,2,0,0,0,0,2,0,0,0,0,0,0,2,2,0,0,0,0,0,0,2,0,0,0,0,2,0],
    [0,2,0,0,0,0,2,0,0,0,0,0,0,2,2,0,0,0,0,0,0,2,0,0,0,0,2,0],
    [0,2,0,0,0,0,2,0,0,0,0,0,0,2,2,0,0,0,0,0,0,2,0,0,0,0,2,0],
    [0,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,0],
    [0,2,0,0,0,0,2,0,0,0,0,0,0,2,2,0,0,0,0,0,0,2,0,0,0,0,2,0],
    [0,2,0,0,0,0,2,0,0,0,0,0,0,2,2,0,0,0,0,0,0,2,0,0,0,0,2,0],
    [0,2,0,0,0,0,2,0,0,0,0,0,0,2,2,0,0,0,0,0,0,2,0,0,0,0,2,0],
    [0,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,0],
    [0,2,0,0,0,0,2,0,0,0,0,0,0,2,2,0,0,0,0,0,0,2,0,0,0,0,2,0],
    [0,3,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,3,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
  ],
  metadata: {
    pacmanSpawn: [14, 23],
    ghostHouseTopLeft: [11, 13],
    ghostHouseSize: [6, 3],
    tunnelPositions: [[0, 14], [27, 14]],
  },
};
